/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Type } from '@app/settings/types/types.model';
import { Model } from '@app/shared/models/model.model';

export class Contact extends Model {
  type: Type;
  type_id?: number;
  value: string;
  note?: string;
}
